export default {
    bindings: {
        treatments: '<',
        categories: '<'
    },
    controller: 'treatmentListController',
    template: require('../views/treatment.list.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/treatment/components/treatment.list.component.js